module.exports = __webpack_public_path__ + "assets/3063479c31202a0d1ecf707b2a4ce742.js";